module.exports = __webpack_public_path__ + "img/超⼤规模的机器学习模型训练.4ae92789.png";